import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import API from '../../api';
import { PaymentMethods } from '../../constants/PaymentTypes';
import { sendNewRelicMessage } from '../../utils/NewRelicUtils';
import { setAppMode } from '../AppModeState/AppModeState.actions';
import { AppMode } from '../AppModeState/AppModeState.types';
import { saveConfigs } from '../ConfigState/ConfigState.actions';
import { getMopOnFile, getMopOnFileFailure, getMopOnFileSuccess, isLoadingMopOnFile, setSelectedMop, setYifteeMop, yifteeInitialization } from './MopOnFileState.actions';
import { getPaymentMethodFilters, splitMops } from './MopOnFileState.helpers';
export var GetMopOnFileLogic = function GetMopOnFileLogic(middleware) {
  return middleware.startListening({
    actionCreator: getMopOnFile,
    effect: function () {
      var _effect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
        var getState, dispatch, _getState, config, supportedPaymentMethods, paymentForm, paymentErrorModal, paymentMethodFilters, response, _splitMops, yiftee, paymentMethods;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _objectDestructuringEmpty(_ref);
              getState = _ref2.getState, dispatch = _ref2.dispatch;
              dispatch(isLoadingMopOnFile({
                isLoadingMops: true
              }));
              _getState = getState(), config = _getState.config;
              supportedPaymentMethods = config.supportedPaymentMethods, paymentForm = config.paymentForm, paymentErrorModal = config.paymentErrorModal;
              paymentMethodFilters = getPaymentMethodFilters(supportedPaymentMethods);
              _context.next = 8;
              return API.getMop({
                paymentMethods: paymentMethodFilters
              });
            case 8:
              response = _context.sent;
              if (response) {
                if (response.errors) {
                  sendNewRelicMessage("GetMopLogic: ".concat(JSON.stringify(response.errors)));
                  dispatch(getMopOnFileFailure(response));
                  dispatch(setAppMode({
                    mode: AppMode.ADD,
                    goBackMode: AppMode.LOADING
                  }));
                } else {
                  _splitMops = splitMops(response.data, paymentForm, paymentErrorModal), yiftee = _splitMops.yiftee, paymentMethods = _splitMops.paymentMethods;
                  if (paymentMethods.length > 0) {
                    dispatch(setSelectedMop({
                      mop: paymentMethods[0]
                    }));
                    dispatch(setAppMode({
                      mode: AppMode.DEFAULT_MOP,
                      goBackMode: AppMode.DEFAULT_MOP
                    }));
                  } else {
                    dispatch(setAppMode({
                      mode: AppMode.ADD,
                      goBackMode: AppMode.DEFAULT_MOP
                    }));
                  }
                  dispatch(getMopOnFileSuccess({
                    data: paymentMethods
                  }));
                  if (yiftee) {
                    dispatch(setYifteeMop({
                      mop: yiftee
                    }));
                    dispatch(yifteeInitialization({}));
                  }
                }
              }
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function effect(_x, _x2) {
        return _effect.apply(this, arguments);
      }
      return effect;
    }()
  });
};
export var YifteeInitializationLogic = function YifteeInitializationLogic(middleware) {
  return middleware.startListening({
    actionCreator: yifteeInitialization,
    effect: function () {
      var _effect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3, _ref4) {
        var getState, dispatch, _getState2, config, mopOnFile, priceSummary, supportedPaymentMethods, yifteeMop, balance, yifteeCoveringFull;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _objectDestructuringEmpty(_ref3);
              getState = _ref4.getState, dispatch = _ref4.dispatch;
              _getState2 = getState(), config = _getState2.config, mopOnFile = _getState2.mopOnFile;
              priceSummary = config.priceSummary, supportedPaymentMethods = config.supportedPaymentMethods;
              if (priceSummary && supportedPaymentMethods.includes(PaymentMethods.YIFTEE)) {
                yifteeMop = mopOnFile.yifteeMop;
                balance = yifteeMop ? yifteeMop.totalAvailable || 0 : 0;
                yifteeCoveringFull = balance >= priceSummary.subtotal;
                dispatch(saveConfigs({
                  yiftee: {
                    yifteeCoveringFull: yifteeCoveringFull,
                    balance: balance
                  }
                }));
                if (yifteeCoveringFull) {
                  dispatch(setAppMode({
                    mode: AppMode.YIFTEE_FULL_COVERAGE,
                    goBackMode: AppMode.LOADING
                  }));
                }
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function effect(_x3, _x4) {
        return _effect2.apply(this, arguments);
      }
      return effect;
    }()
  });
};
export default [GetMopOnFileLogic, YifteeInitializationLogic];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/MopOnFileState/MopOnFileState.listener.js
// module id = 4382
// module chunks = 11